// 📁 src/components/Promo/PromoBanner.jsx

import React, { useEffect, useState } from 'react';
import '../../styles/promoBanner.css';

export default function PromoBanner() {
  const [visible, setVisible] = useState(false);
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    try {
      const local = localStorage.getItem('activePromo');
      if (local) {
        const parsed = JSON.parse(local);
        const now = new Date();
        const from = new Date(parsed.validFrom);
        const to = new Date(parsed.validTo);

        console.log('🧭 PromoBanner validation:', { now, from, to, parsed });

        if (parsed.occasion && parsed.discountRate && from <= now && to >= now) {
          setPromo(parsed);
          setVisible(true);
        }
      }
    } catch (err) {
      console.warn('Invalid promo data:', err);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible((prev) => !prev);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  if (!promo) return null;

  return (
    <div className={`promo-banner ${visible ? 'show roman-flip-in' : 'hide'}`}>
      🎉 {promo.occasion} — Save {promo.discountRate}% until {promo.validTo}
    </div>
  );
}
